export default "__VITE_ASSET__Dz06t_QO__"